var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-image',{attrs:{"src":_vm.href,"crossorigin":"anonymous","referrerpolicy":"no-referrer"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }